import { useState } from "react";
import "../../App.css";
import Listdelete from "./ListDelete";

function Users() {
  const [counter, setCounter] = useState(0);
  const [pageNumber, setPageNumber] = useState("1");

  const increment = () => {
    setCounter(counter + 1);
  };

  return (
    <div className="App">
      <Listdelete
        increment={increment}
        counter={counter}
        setCounter={setCounter}
        pageNumber={pageNumber}
        setPageNumber={setPageNumber}
      />
    </div>
  );
}

export default Users;
